import { getGuid } from 'owa-guid';
import { is3SFeatureEnabled } from 'owa-mail-feature-flags';
import {
    lazyLogLocalContentDataSource,
    LocalContentInstrumentationContext,
    LocalContentProvider,
    LocalContentType,
    Suggestion,
    SuggestionKind,
    SubstrateSearchScenario,
} from 'owa-search-service';

export function logClientSuggestions(
    traceId: string,
    instrumentationContext: {
        [providerName: string]: LocalContentInstrumentationContext[];
    }
) {
    if (!is3SFeatureEnabled('sea-qf')) {
        return;
    }

    Object.keys(instrumentationContext).forEach(providerName => {
        lazyLogLocalContentDataSource.importAndExecute(
            traceId,
            providerName as LocalContentProvider,
            instrumentationContext[providerName],
            SubstrateSearchScenario.Mail
        );
    });
}

export function createClientSuggestionInstrumentationContext(
    clientSuggestions: Suggestion[],
    type: LocalContentType
): LocalContentInstrumentationContext[] {
    const localContentInstrumentationContexts: LocalContentInstrumentationContext[] = [];

    clientSuggestions.forEach(clientSuggestion => {
        localContentInstrumentationContexts.push({
            localContentId: getGuid(),
            entityId: clientSuggestion.ReferenceId,
            contentType: type,
        });
    });

    return localContentInstrumentationContexts;
}

export function getLocalContentInstrumentationType(
    suggestionKind: SuggestionKind
): LocalContentType {
    switch (suggestionKind) {
        case SuggestionKind.Category:
            return 'category';
    }

    return 'unknown';
}
